module.exports = __webpack_public_path__ + "public/img/cpbg.2d9f9d62.png";